import { Controller } from "@hotwired/stimulus"
import { ACTIVE_BUDGET_KEY } from "./budget_carousel_controller"

// The header colours just picked, "#RRGGBB,#RRGGBB,#RRGGBB". The dashboard
// under the Settings sheet listens for it (bridge/nav_bar_controller) and
// recolours its band and native bar in place.
export const HEADER_GRADIENT_KEY = "header-gradient-picked"

// The header colour picker. Shows the card the dashboard was last on
// (budget_carousel_controller writes ACTIVE_BUDGET_KEY), same is-active /
// hidden swap the dashboard stage uses, and hands each pick to the dashboard.
export default class extends Controller {
  connect() {
    let id = null
    try { id = localStorage.getItem(ACTIVE_BUDGET_KEY) } catch { return }
    const cards = Array.from(this.element.querySelectorAll("[data-budget-skin-id]"))
    const active = cards.find(card => card.dataset.budgetSkinId === id)
    if (!active) return

    cards.forEach(card => {
      const on = card === active
      card.classList.toggle("is-active", on)
      card.classList.toggle("hidden", !on)
    })
  }

  pick(event) {
    try {
      localStorage.setItem(HEADER_GRADIENT_KEY, event.currentTarget.dataset.colors)
    } catch (error) {
      console.warn("Header colours not handed to the dashboard:", error)
    }
  }
}
